module.exports = __webpack_public_path__ + "img/mobile_with_beak.7cba7128.svg";